import { createAction } from "@reduxjs/toolkit";
import { FundsState } from "@funds/models";

export const changeFundDocumentsFilterValue = createAction<Partial<FundsState["fundDocumentsFilters"]>>(
  "funds/changeFundDocumentsFilterValue"
);

export const resetFundDocumentsFilters = createAction("funds/resetFundDocumentsFilters");
